import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLazyQuery } from '@apollo/client'
import { GET_CONTENT } from '../../services/content/query'
import { EN } from '../../services/languages/constants'
import {
  createTitleGroupId,
  CONTENT_IMAGE_LIST,
} from '../../services/content/index'
import { APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY } from '../../services/apollo-graphql/index'

function ContentUpdater (props) {
  const {
    contentId,
    contentType,
    secondaryContentId,
    secondaryContentType,
    userLanguage,
    authJwt,
  } = props
  const titleGroupIds = []

  if (contentId && contentType) {
    titleGroupIds.push(createTitleGroupId(contentId, contentType))
  }

  if (secondaryContentId && secondaryContentType) {
    titleGroupIds.push(createTitleGroupId(secondaryContentId, secondaryContentType))
  }
  const [updateContent] = useLazyQuery(GET_CONTENT)
  const language = [userLanguage, '_primary']

  useEffect(() => {
    const { runOnMount } = props

    if (runOnMount) {
      updateContent({
        variables: {
          language,
          primaryLanguage: [userLanguage],
          titleGroupIds,
          imageType: CONTENT_IMAGE_LIST,
          limitedData: true,
          includeSeriesImage: false,
          learnerLevelLanguage: userLanguage,
        },
        fetchPolicy: APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
        context: {
          jwt: authJwt,
        },
      })
    }

    return () => {
      if (!runOnMount) {
        updateContent({
          variables: {
            language,
            primaryLanguage: [userLanguage],
            titleGroupIds,
            imageType: CONTENT_IMAGE_LIST,
            limitedData: true,
            includeSeriesImage: false,
            learnerLevelLanguage: userLanguage,
          },
          fetchPolicy: APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
          context: {
            jwt: authJwt,
          },
        })
      }
    }
  }, [])

  return <></>
}

ContentUpdater.propTypes = {
  contentId: PropTypes.number.isRequired,
  contentType: PropTypes.string.isRequired,
  secondaryContentId: PropTypes.number,
  secondaryContentType: PropTypes.string,
  authJwt: PropTypes.string.isRequired,
  userLanguage: PropTypes.string.isRequired,
}

ContentUpdater.defaultProps = {
  userLanguage: EN,
  runOnMount: false,
}

export default ContentUpdater
